export { COUNTRIES } from './countries';

export { STATES } from './states';

export { COUNTRY_CODES, CountryCode } from './countryCodes';

export const COLOR_COUNT = 30;

export enum SessionStorageKey {
  CONTENT_LIBRARY_FOLDER_ID = 'content_library_folder_id',
  CONTENT_LIBRARY_FOLDER_PARENTS_IDS = 'content_library_folder_parents_ids',
}

/**
 * @deprecated Please use CamelCase variant {@link SessionStorageKey}
 */
export const SESSION_STORAGE_KEYS = SessionStorageKey;

export enum DateFormatLocalized {
  SHORT_DATE = 'PP',
  SHORT_DATE_AND_TIME = 'PPp',
  LONG_DATE = 'PPP',
  LONG_DATE_AND_TIME = 'PPPp',
  TIME = 'p',
  MONTH_AND_YEAR = 'LLLL yyyy',
}

export enum DateFormatStandard {
  HYPHEN_DATE = 'yyyy-MM-dd',
  HYPHEN_DATE_AND_TIME = 'yyyy-MM-dd HH:mm:ss',
  HYPHEN_T_DATE_AND_TIME = `yyyy-MM-dd'T'HH:mm:ss`,
  LONG_DATE_AND_TIME = 'MMMM dd, yyyy',
}
